import SecureAPI from '../../services/api/SecureAPI';

class SecureBaseModel extends SecureAPI {

    static STATUS_SUCCESS = "SUCCESS";

    constructor() {
        super(true);
    }

    async getData(entityName, params = {}) {
        return await this.get(entityName, params);
    }

    async saveData(entityName, params = {}) {
        return await this.post(entityName, params);
    }

    async postData(entityName, params = {}) {
        return await this.post(entityName, params);
    }

    async removeData(entityName, params = {}) {
        return await this.delete(entityName, params);
    }

    getErrorResponse = (err) => {
        let response = {
            status: "ERROR",
            description: err.message + ' - Failed to connect to server'
        };
    
        // Set status_code only if it's a network error
        let isNetworkError = err.message && err.message.toLowerCase().includes('network error');
        if(isNetworkError) response.status_code = "NETWORK_ERROR";
        return response;
    };
}

export default SecureBaseModel;
